import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-more-vertical',
  standalone: true,
  templateUrl: '../../assets/more-vertical.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamMoreVerticalIcon {}
